module.exports = __webpack_public_path__ + "img/Radiator.499dff39.jpg";